<template>
    <div class="c-row mKasaPromoItems">
        <div class="c-tr">
            <div class="c-tw">
                <div class="c-td is-1">
                    <strong>{{ months[data.month] }} {{ data.year }}</strong>
                </div>
                <div class="c-td is-2">
                    <div class="typo-label">Użyte promocje</div>
                    {{ (+data.promo_with_usage_count_avg).toFixed(1) }}
                </div>
                <div class="c-td is-3">
                    <div class="typo-label">Cel użytych promocji</div>
                    {{ data.promo_limit_avg }}
                </div>
                <div class="c-td is-5">
                    <button
                        class="btn btn-auto c-promos-toggle"
                        @click="showWeeks = !showWeeks"
                    >
                        <span class="d-inline d-lg-none">Tygodnie</span>
                        <a-icon icon="Dropdown" />
                    </button>
                </div>
            </div>
        </div>
        <div
            class="c-tm collapse"
            :class="{ show: showWeeks }"
            v-if="data.weeks"
        >
            <h4 class="h5">Tygodnie</h4>

            <table class="t">
                <tbody>
                    <tr v-for="(week, idxx) in data.weeks" :key="idxx">
                        <td class="t-d is-1">
                            {{ `Tydzień ${week.number}` }} <br />
                            {{ dateOfWeek(week.number, data.month, data.year) }}
                        </td>
                        <td class="t-d is-2">
                            <div class="typo-label">Użyte promocje</div>
                            {{ (+week.promo_with_usage_count).toFixed(1) }}
                        </td>
                        <td class="t-d is-3">
                            <div class="typo-label">Cel użytych promocji</div>
                            {{ week.promo_limit }}
                        </td>
                        <td class="t-d is-5"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import months from '@/dictionaries/months'
export default {
    data() {
        return {
            showWeeks: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    methods: {
        dateOfWeek(week, month, year) {
            const friday = this.$moment()
                .year(year)
                .month(month - 1)
                .startOf('month')
                .day('Friday')
            if (friday.date() > 7) friday.add(1, 'weeks')
            friday.add(week - 1, 'weeks')
            const monday = friday.subtract(4, 'days').format('DD.MM')
            const sunday = friday.add(6, 'days').format('DD.MM')

            return monday + ' - ' + sunday
        }
    },
    computed: {
        months() {
            return months
        }
    }
}
</script>
